export const isLmsPreviewActionDisabled = rowData => {
  if (!rowData?.hasMoodleLink) {
    return true;
  }

  const templateId = rowData && rowData.id;
  if (!templateId) {
    return true;
  }

  return Number.isNaN(Number(templateId));
};
